import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CompassSynthVisual"] */ "/vercel/path0/src/components/marketing/home/compass-synth-visual.tsx");
